export default {
  mapLeftClick: {
    placeInfo: 'Informații despre locație',
    polygonArea: 'Suprafața poligonului',
    copyLnglat: 'Copiați lng, lat',
    copyLatlng: 'Copiați lat, lng',
    directionsToClickedPoint: 'Direcții de acces la locul indicat',
    latlngCopied: 'Longitudine și latitudine copiate',
    placeInsidePolygon: 'Așezați în interiorul poligonului',
    lnglatCopied: 'Longitudine și latitudine copiate',
  }
}
